import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Spouse } from '../../../../models/users/dto/spouse';

@Component({
  selector: 'app-member-spouse-information-details',
  templateUrl: './member-spouse-information-details.component.html',
  styleUrls: ['./member-spouse-information-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MemberSpouseInformationDetailsComponent {
  @Input() spouse!: Spouse;
  @Input() disabled = false;
  @Output() editClicked = new EventEmitter<void>();
}
